import React, { useEffect, useMemo, useRef, useState } from 'react';

import { getGroupedJackpotByName } from "@common/components/jackpot/helper/groupJackpot";
import JackpotCardBackground from "@common/components/jackpot/card/background";
import MoneyAmount from "@common/components/jackpot/helper/moneyAmount";
import Dollar from '../../../assets/images/jackpot/dollar.png';
import Trophy from '../../../assets/images/jackpot/trophy.png';
import { useTranslation } from "@common/hooks/translation";
import Ball from '../../../assets/images/jackpot/ball.png';
import Gift from '../../../assets/images/jackpot/gift.png';

import './style.scss';

 const JackpotListPopup = ({ state, jackpotName, closePopup, mode, theme, config, subscribeToJackpotState }) => {
  const t = useTranslation();
  const tierIcons = [Trophy, Ball, Dollar, Gift];
  const [liveState, setLiveState] = useState(state);
  const hasInitializedRef = useRef(false);

  useEffect(() => {
    setLiveState(state);
    hasInitializedRef.current = false;
  }, [jackpotName, state]);

  useEffect(() => {
    if (typeof subscribeToJackpotState !== 'function') {
      return undefined;
    }

    const unsubscribe = subscribeToJackpotState((nextState) => {
      setLiveState(() => {
        hasInitializedRef.current = true;
        return nextState;
      });
    });

    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, [subscribeToJackpotState]);

  const data = useMemo(() =>
    getGroupedJackpotByName(liveState?.data, jackpotName),
  [liveState?.data, jackpotName]);

    if (!data) return null;

  return (
    <div className="jackpot-modal-wrapper">
      <i className="global-icon icon-Close" onClick={closePopup} />
      <div className="jackpot-container">
        <div className="jackpot-card">
          <JackpotCardBackground theme={theme} mode={mode} />
          <div className="jackpot-card-content">
            <h3>{data.name}</h3>
            <h1>
              <MoneyAmount config={config} currencyConfig={{ name: data.currencyId }} amount={data.totalAmount} round={data.spinningRounding} />
            </h1>
          </div>
        </div>
        <div className="jackpot-tiers">
          {data.rawData.map((item, index) => {
            const iconSrc = tierIcons[index] || Trophy;

            return(
            <div key={item.levelId} className="jackpot-content">
              <div className="card-top">
                <img
                  src={iconSrc}
                  alt={item.levelName}
                  className={`tier-icon ${tierIcons[index] === Ball ? 'tier-icon-ball' : ''} ${tierIcons[index] === Trophy ? 'tier-icon-trophy' : ''}`}
                />
                <div className="tier-info">
                  <span className="tier-label">{item.levelName}</span>
                  <span className="tier-amount"><MoneyAmount amount={item.amount} currencyConfig={{ name: item.currencyId }} config={config} round={item.spinningRounding} /></span>
                </div>
              </div>

              <div className="card-bottom">
                {<div className="info-row">
                  <span className="label">{t('Last Win on:')}</span>
                  <span className="value">{item.lastWinDate ? item.lastWinDate : '-'}</span>
                </div>}
                <div className="info-row">
                  <span className="label">{t('Bet ID:')}</span>
                  <span className="value">{item.betId ||  '-'}</span>
                </div>
                <div className="info-row">
                  <span className="label">{t('Win Amount:')}</span>
                  <span className="value win-amount-value">
                    <MoneyAmount config={config} currencyConfig={{ name: data.currencyId }} amount={item.lastWinAmount} round={item.winningRounding}/>
                  </span>
                </div>
              </div>
            </div>
          )})}
        </div>
      </div>
    </div>
  );
};

export default JackpotListPopup;
